import React from 'react';
import Layout, {PureLayoutProps} from '../Layout';
import Loading from '../Loading';
import {useSelector} from 'react-redux';
import {getSessionError} from '../../redux/session/selectors';
import {getPricingError} from '../../redux/pricing/selectors';
import {noPriceMessage} from '../../constants';
import ErrorAlert from '../Alerts/ErrorAlert';
import {Box, breakpoint, Container} from '@nib/layout';
import styled from 'styled-components';
import {token} from '@nib-components/theme';

type QuotePageLayoutProps = {
  hidePageContents?: boolean;
  pageData?: PureLayoutProps['pageData'];
  showCorporateBanner?: boolean;
  welcomeV2?: boolean;
};

const QuoteV2Box = styled(Box)`
  background: ${token('theme.color.bg')};
  ${breakpoint('lg')`
    background: linear-gradient(to right, ${token('theme.color.bg')} 60%, white 40%);
  `};
`;
const QuotePageLayout: React.FC<QuotePageLayoutProps> = ({children, pageData, hidePageContents, showCorporateBanner = false, welcomeV2}) => {
  const sessionError = useSelector(getSessionError);
  const pricingError = useSelector(getPricingError);

  return (
    <Layout pageData={pageData} showCorporateBanner={showCorporateBanner}>
      {welcomeV2 && (
        <>
          {sessionError ? (
            <Container>
              <ErrorAlert />
            </Container>
          ) : (
            pricingError && (
              <Container>
                <ErrorAlert title={noPriceMessage} />
              </Container>
            )
          )}
          <QuoteV2Box>
            <Container>{hidePageContents ? <Loading center={true} /> : children}</Container>
          </QuoteV2Box>
        </>
      )}
      {!welcomeV2 && (
        <Container>
          {sessionError ? <ErrorAlert /> : pricingError && <ErrorAlert title={noPriceMessage} />}
          {hidePageContents ? <Loading center={true} /> : children}
        </Container>
      )}
    </Layout>
  );
};

export default QuotePageLayout;
